"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a query string from the give object by joining all its property values. Does not add ? prefix.
 */
exports.stringifyQuery = function (object, includeUndefinedAndNulls) {
    if (includeUndefinedAndNulls === void 0) { includeUndefinedAndNulls = false; }
    if (!object) {
        return '';
    }
    var params = [];
    Object.keys(object)
        .filter(function (index) {
        var value = object[index];
        return includeUndefinedAndNulls || (value !== undefined && value !== null);
    })
        .forEach(function (key) {
        var value = object[key];
        params.push(key + (value ? '=' + encodeURIComponent(value) : ''));
    });
    return params.join('&');
};
//# sourceMappingURL=stringifyQuery.js.map